module.exports = __webpack_public_path__ + "img/foodable-icon.27a17cff.svg";